import {LastReplacementDatePicker} from '../components/LastReplacementDatePicker';
import {LastReplacementMileageInput} from '../components/LastReplacementMileageInput';
import {NextReplacementDatePicker} from '../components/NextReplacementDatePicker';
import {NextReplacementMileageInput} from '../components/NextReplacementMileageInput';
import {ReplacementAfterMileageInput} from '../components/ReplacementAfterMileageInput';
import {ReplacementAfterMonthsInput} from '../components/ReplacementAfterMonthsInput';

export function TimingBeltReplacementGroup() {
  return (
    <>
      <LastReplacementDatePicker name="timingBelt" />
      <LastReplacementMileageInput name="timingBelt" />
      <NextReplacementDatePicker name="timingBelt" />
      <NextReplacementMileageInput name="timingBelt" />
      <ReplacementAfterMonthsInput name="timingBelt" />
      <ReplacementAfterMileageInput name="timingBelt" />
    </>
  );
}
